// extracted by mini-css-extract-plugin
export default {"EmbedCalendar":"EmbedCalendar_EmbedCalendar__FM9Tl","attribution":"EmbedCalendar_attribution__8-MOW","state":"EmbedCalendar_state__lmenL"};